import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, joinAuction, setisjoin } from "../../actions/index";
// import { useHistory } from "react-router-dom";

import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";

function JoinauctionCode(match) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setJoinAuction);

  const [data, setData] = useState(
    getpageData ? getpageData.response.data.detail : {}
  );
  const [isActive, setActive] = useState(false);
  //   const getpageData = useSelector((state) => state.setactlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const [isDisabled, setDisabled] = useState(false);
  //   const refresh = useSelector((state) => state.setRefresh);
  //   const history = useHistory({ forceRefresh: true });
  const [cid, setCid] = useState(loginuser["cid"]);
  const [path, setpath] = useState('');
  const [bannerData, setBannerData] = useState(null);
  const [bnpath, setBnpath] = useState('');
  const history = useHistory({ forceRefresh: true });

  const onSubmit = (values) => {
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
        "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
      },
    };
    DataService.JoinauctionCode(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        dispatch(joinAuction({ response, values }));

        if (response.success == true) {
          toast.success("UPDATE PLAYER PROFILE", {
            theme: "dark",
            position: "bottom-center",
          });
          history.push(BASE_PATH + "join-auction");
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
    localStorage.removeItem('acode')
  };

  const fetchData = async () => {
    //  console.log("cid" + cid)
    //  console.log(loginuser["token"])
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.getJoinAuction({ cid: cid }, hdr)
      .then((res) => {
        let response = res.data;
       
        if (response.success == true) {
          let responsedata = response.data;
          setData(responsedata);
          dispatch(actlistData({ responsedata }));
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };

  const setauction = (ai, an) => {
    localStorage.setItem("auction_id", ai);
    localStorage.setItem("auction_name", an);
  };
  function tologin() {
    dispatch(setisjoin("true"));
    history.push('/')
  }
  useEffect(() => {
    
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
        "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
      },
    };
    DataService.JoinauctionCode2({ 'acode': localStorage.getItem('acode') }, hdr)

      .then((res) => {
        let response = res.data;
        //  console.log("response dikhaaa");
        //  console.log(response);
        // toast.dismiss(toastContainerId);

        dispatch(joinAuction({ response }));
        if (response.success == true) {
           console.log(response)
          setData(response.data.act)
          setpath(response.data.path)
          setBannerData(response.data.banner)
          setBnpath(response.data.bnpath)

          toast.success("Got Auction", {
            theme: "dark",
            position: "bottom-center",
          });
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        // setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        //   toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });

    window.scrollTo(0, 0);
  }, []);
function joinPlyercode(){
  //  console.log('triggered inside the joinplayer code func.')
}
  return (
    <>
      <LoadingOverlay
        active={isActive}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        <div className="jinfo-main" style={{ width: '100%' }}>
          <div
            className="container-fluid"
            style={{
              padding: '40px 0px',
              width: '100%',
              maxWidth: '100%',
              margin: '0 auto'
            }}
          >
            <div
              className="row"
              style={{
                alignItems: 'center',
                minHeight: '500px',
                margin: 0,
                paddingTop: 0,
                justifyContent: 'center'
              }}
            >
              {/* Left Half - Banner Image - Only show if banner data exists */}
              {bannerData && bannerData.img && bnpath && (
                <div className="col-md-6" style={{ textAlign: 'center' }}>
                  <div className="banner-section">
                    <img
                      src={bnpath + bannerData.img}
                      alt="Auction Banner"
                      className="banner-image-mobile"
                      style={{
                        width: '100%',
                        height: '400px',
                        objectFit: 'contain',
                        border: '3px solid #186cc2',
                        borderRadius: '20px',
                        boxShadow: '0 8px 25px rgba(24, 108, 194, 0.3), 0 4px 10px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease'
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                </div>
              )}

              {/* Right Half - Auction Logo and Info */}
              <div className={bannerData && bannerData.img && bnpath ? "col-md-6" : "col-md-12"}
                style={{ textAlign: 'center', maxWidth: bannerData && bannerData.img && bnpath ? 'unset' : 720, margin: bannerData && bannerData.img && bnpath ? undefined : '0 auto' }}>
                <div className="auction-info-landing auction-info-mobile">
                  {data && (
                    <div className="auction-details">
                      <div className="auction-logo" style={{ marginBottom: '10px' }}>
                        <Image
                          src={
                            data && data.alogo != null
                              ? path + data.alogo
                              : auctiondefaultLogo
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = auctiondefaultLogo;
                          }}
                          fallback={<Shimmer width={100} height={100} />}
                          style={{ width: '100px', height: '100px', borderRadius: '50%' }}
                        />
                      </div>
                      <div className="auction-text">
                        <h2 style={{ color: '#186cc2', marginBottom: '5px', fontSize: '28px' }}>{data.auctionname}</h2>
                        <p style={{ fontSize: '18px', marginBottom: '15px', color: '#333' }}>Auction on: {data.dt}</p>

                        {/* Join Button */}
                        <div className="register-button-section">
                          <button
                            onClick={tologin}
                            style={{
                              backgroundColor: '#186cc2',
                              color: 'white',
                              border: 'none',
                              padding: '18px 45px',
                              fontSize: '20px',
                              borderRadius: '8px',
                              cursor: 'pointer',
                              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                              transition: 'all 0.3s ease',
                              fontWeight: 'bold'
                            }}
                            onMouseOver={(e) => {
                              e.target.style.backgroundColor = '#135a9e';
                              e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.backgroundColor = '#186cc2';
                              e.target.style.transform = 'translateY(0)';
                            }}
                          >
                            I want to Join
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default JoinauctionCode;
